import { Box, Button, Dialog, DialogContent, Typography } from "@mui/material";
import React, { useState } from "react";
import { ReactComponent as AlertTriangleIcon } from '../../assets/alert-triangle.svg';
import { getCurrentTaxYear } from "../../functions/misc";
import { TaxReturnTranscriptModal } from "./tax-return-transcript-modal";
import { clientConfig } from "../../awsClientConfig";
import { UpdateProfileAlert } from "../../queries/UpdateProfileAlert";

export interface ItemModalProps {
    alertData: any;
    onDisagree: (alertId: string) => void;
    onAgree: (alertId: string) => void;
    open: boolean;
  }

  export function TaxIdTheftAlertModal({ alertData, onDisagree, onAgree, open = false }: ItemModalProps): React.JSX.Element {
    const [showTranscriptModal, setShowTranscriptModal] = useState(false);
    const [disable, setDisable] = useState(false);
    const client = new clientConfig();

    const onActionHandler = async (returnsFiled: boolean) => {
      const alertVaraiables = {
        Active: false,
        ProfileAlertId: alertData.ProfileAlertId,
        ProfileId: alertData.ProfileId,
        TriggerAlert: returnsFiled
      }
      try{
        setDisable(true);
        await client.mutate({ mutation: UpdateProfileAlert, variables: alertVaraiables});
      }catch(error){
        console.log(error);
      }finally{
        setDisable(false);
        if(returnsFiled){
          onAgree(alertData.ProfileAlertId);
        }else {
          onDisagree(alertData.ProfileAlertId);
        }
      }
    }

    return (
        <>
        <Dialog open={open} sx={{justifyContent: 'center'}} maxWidth={'sm'}>
            <DialogContent sx={{mt: 2}}>
                <Box sx={{display: 'flex', flexDirection:'column', justifyContent: 'center', alignItems: 'center'}}>
                    <AlertTriangleIcon />
                    <Typography variant="h5" sx={{textAlign: 'center', mt: 2}}>
                    {'Tax ID Theft Alert!'}
                    </Typography>
                    <Typography sx={{textAlign: 'center', mt: 2}}>
                    Optima has detected a filing activity on your tax account for the tax year: <b>{`${alertData?.TaxYear}`}</b>. Please confirm whether this was a tax return you filed. If so, we will continue to monitor your account for your safety and security. If not, we will help you with next steps.
                    </Typography>
                    <Typography sx={{textAlign: 'center', mt: 2, cursor: 'pointer', color: '#1D89D2'}} onClick={() => {setShowTranscriptModal(true)}}>
                    View the Tax Return that was Filed
                    </Typography>
                    <Box sx={{mt:3}}>
                      <Button className="option-red-button me-3" disabled={disable} onClick={() => onActionHandler(false)}>No, I did NOT file a tax return</Button>
                      <Button className="option-primary-button" disabled={disable} onClick={() => onActionHandler(true)}>Yes, I filed a tax return</Button>
                    </Box>
                </Box>
            </DialogContent>
        </Dialog>

        {showTranscriptModal && <TaxReturnTranscriptModal onClose={() => {setShowTranscriptModal(false)}} open={showTranscriptModal} alertData={alertData} /> }

        </>
      )

  }